module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-company-acd"
  }, [_vm._l((_vm.acdAgents), function(acdAgent) {
    return _c('div', {
      staticClass: "panel cc-panel-default"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-user fa-lg",
      class: {
        'loading': _vm.loading
      },
      style: ({
        color: _vm.getColor(acdAgent.status)
      }),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(acdAgent.name))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(acdAgent.id) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("\n            " + _vm._s(acdAgent.status) + "\n          ")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.acdAgents.length),
      expression: "!acdAgents.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine ACD Agenten gefunden")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b63f0c30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CompanyAcd.vue
// module id = 288
// module chunks = 0